import { AutoCompleteProps } from "common/Component/Autocomplete/types";
import { Value } from "common/component/Autocomplete/types";
import { StatusLine } from "common/component/StatusLine";
import { fromStyleLocals } from "common/css";
import { AutocompleteState } from "common/picker/reducer/types";
import { removeDiacritics } from "common/stringUtils";
import { Component, h } from "preact";
import * as stylesheet from "./Autocomplete.less";
const css = fromStyleLocals(stylesheet.locals);
import { isEmpty } from "lodash";
import { VirtualList } from "common/component/Autocomplete/VirtualList/VirtualList";

const regExpEscape = (input: string) => {
  return input.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
};

export const highlight = (token = "", src: string) => {
  if (token === "") {
    return removeDiacritics(src);
  }
  const tokenPart = removeDiacritics(token)
    .split(" ")
    .map(regExpEscape)
    .join("|");
  const regex = new RegExp(tokenPart, "gi");
  return removeDiacritics(src).replace(
    regex,
    (highlighted: string) =>
      `<span class='${css("highlight")}'>${highlighted}</span>`
  );
};

export abstract class Autocomplete<TItem, TCriteria> extends Component<
  AutoCompleteProps<TItem, TCriteria> & AutocompleteState<TItem>,
  any
> {
  public render(
    props: AutoCompleteProps<TItem, TCriteria> & AutocompleteState<TItem>
  ) {
    const { onSelect, exclude, items, criteria } = props;
    const data = this.getData(onSelect, exclude, items, criteria);
    return (
      <div class={css("ic-autocomplete")}>
        <style>{stylesheet.toString()}</style>
        {props.isVisible ? (
          <div>
            {props.status === "loaded"
              ? !isEmpty(data)
                ? this.renderList(data)
                : null
              : this.renderStatus(props)}
          </div>
        ) : null}
      </div>
    );
  }

  protected renderRow({ style, onclick, properties }: Value) {
    return (
      <div class={style} onClick={() => onclick()}>
        {properties.map(p => (
          <span class={css("col")} dangerouslySetInnerHTML={{ __html: p }} />
        ))}
      </div>
    );
  }

  protected abstract getData(
    onSelect: (item: TItem) => void,
    exclude: TItem[],
    items: TItem[],
    criteria?: TCriteria
  ): Value[];

  private renderList(data: Value[]) {
    return (
      <VirtualList
        sync
        class={css("scrollable", "full-absolute")}
        data={data}
        rowHeight={42}
        renderRow={this.renderRow}
      />
    );
  }

  private renderStatus(
    props: AutoCompleteProps<TItem, TCriteria> & AutocompleteState<TItem>
  ) {
    return (
      <div class={css("full-absolute")}>
        {props.status !== "init" && (
          <div class="list-group-item">
            <StatusLine status={props.status} reason={props.reason} />
          </div>
        )}
      </div>
    );
  }
}
